import classNames from "classnames";
import React from "react";

interface Props {
  className?: string;
  colourClassName?: string;
}

export const ArrowCircleIcon: React.FC<Props> = ({
  className,
  colourClassName = "text-lazer",
}) => {
  return (
    <svg
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, colourClassName, "stroke-current")}
    >
      <circle cx="28.5" cy="28.5" r="27" strokeWidth="3" />
      <path
        d="M27.4393 44.1957C28.0251 44.7815 28.9749 44.7815 29.5607 44.1957L39.1066 34.6498C39.6924 34.064 39.6924 33.1142 39.1066 32.5284C38.5208 31.9426 37.5711 31.9426 36.9853 32.5284L28.5 41.0137L20.0147 32.5284C19.4289 31.9426 18.4792 31.9426 17.8934 32.5284C17.3076 33.1142 17.3076 34.064 17.8934 34.6498L27.4393 44.1957ZM27 11.554L27 43.135L30 43.135L30 11.554L27 11.554Z"
        className="fill-current"
      />
    </svg>
  );
};
